import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ProductsPage from "@/pages/Products";
import IndustriesPage from "@/pages/Industries";
import QualityPage from "@/pages/Quality";
import ContactPage from "@/pages/Contact";
import AdminPanel from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function App() {
  // Set document title on mount
  useEffect(() => {
    document.title = "Voltron Calcium Pvt Ltd | Industrial Minerals & Chemical Supplier";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Admin Panel - No Layout */}
          <Route path="/admin" element={<AdminPanel />} />
          
          {/* Public Pages - With Layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/products" element={<Layout><ProductsPage /></Layout>} />
          <Route path="/industries" element={<Layout><IndustriesPage /></Layout>} />
          <Route path="/quality" element={<Layout><QualityPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
